<template>
   <div id="content">
      <section id="slider">
         <div class="position-absolute end-0 bootom-0 w-100 h-100 hero-img" style="background: url('/demos/mj/cc_home_banner.png') no-repeat bottom / auto 100%; min-height: 500px;"></div>
         <div class="container py-5 py-lg-6">
            <div class="row align-items-center justify-content-between">
               <div class="col-xl-6 col-lg-7 pt-lg-5 pb-lg-6 ps-5">
                  <div class="position-relative z-1">
                     <div class="fs-6 text-uppercase ls-3 mb-4"></div>
                     <h2 class="mb-0 display-4 lh-1">Crossword Puzzles<br>
                        <span class="font-secondary fw-semibold fst-italic text-lowercase color display-2">Live</span><span>.</span>
                     </h2>
                     <p
                        class="fs-6 mt-3 fw-normal title-text"
                        >
                        Join our multiplayer live Crossword Arena. Compete against other players to solve 
                        5x5 crosswords and climb the leaderboard.
                     </p>
                  </div>
                  <div class="mt-4 mb-5">
                     <a
                        href='/crossword/live'
                        class="button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                     >
                        Play Now
                     </a>
                     <a
                        href='/about'
                        class="button text-dark h-text-dark border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                        style="background-color: white;"
                     >
                        About
                     </a>
                  </div>
               </div>
               <div class="col-lg-5">
               </div>
            </div>
         </div>
      </section>
   </div>
   <div class="section py-lg-6" style="background: linear-gradient(to bottom, var(--cnvs-themecolor) 60%, #FFF 60%); margin: 12rem 0 8rem 0;">
      <div class="container dark" data-bs-theme="dark">
         <div class="row align-items-end mb-5 justify-content-between">
            <div class="col-12 px-4">
               <h2 class="mb-0 display-4 fw-bold">Explore Our Puzzle Collection<br> <span class="font-secondary fw-light fst-italic text-white display-4">Solve</span><small class="mx-3 op-03">·</small><span class="font-secondary fw-light fst-italic text-white display-4">Create</span><small class="mx-3 op-03">·</small><span class="font-secondary fw-light fst-italic text-white display-4">Share</span></h2>
            </div>
         </div>
      </div>
      <div class="slider-element section-podcasts overflow-visible">
         <div class="container-fluid">
            <div class="swiper_wrapper customjs overflow-visible h-auto">
               <div class="swiper swiper-parent overflow-visible swiper-initialized swiper-horizontal swiper-backface-hidden">
                  <div class="swiper-wrapper" id="swiper-wrapper-e072d86d430a899c" aria-live="polite" style="cursor: grab; transition-duration: 0ms; transform: translate3d(0px, 0px, 0px); transition-delay: 0ms;">
                     <div class="swiper-slide swiper-slide-active" role="group" aria-label="1 / 6" style="width: 374.5px; margin-right: 40px;" data-swiper-slide-index="0">
                        <div class="d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg">
                           <h3 class="mb-3">
                              Live Arena
                           </h3>
                           <img g src="/demos/mj/cc_gameplay.png" alt="Gameplay" class="mb-5">
                           <p class="text-muted mb-0 feature-slider-text">
                              <strong class="font-secondary"> Race against other players in the Live Arena</strong> - there's always a game waiting for you.
                           </p>
                           <a
                              href="/crossword/live"
                              target="_blank"
                              class="button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                           >
                              Play Now
                           </a>
                        </div>
                     </div>
                     <div class="swiper-slide swiper-slide-active" role="group" aria-label="2 / 6" style="width: 374.5px; margin-right: 40px;" data-swiper-slide-index="0">
                        <div class="d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg">
                           <h3 class="mb-3">
                              Daily Puzzles
                           </h3>
                           <img g src="/demos/mj/cc_daily_puzzle_gameplay.png" alt="Gameplay" class="mb-5">
                           <p class="text-muted mb-0 feature-slider-text">
                              <strong class="font-secondary">Check out our daily mini puzzle</strong> and race solve the in the fastest
                              time.
                           </p>
                           <a
                              href="/crossword/daily"
                              target="_blank"
                              class="button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                           >
                              Play Now
                           </a>
                        </div>
                     </div>
                     <div class="swiper-slide swiper-slide-active" role="group" aria-label="3 / 6" style="width: 374.5px; margin-right: 40px;" data-swiper-slide-index="0">
                        <div class="d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg">
                           <h3 class="mb-3">
                              Community Puzzles
                           </h3>
                           <img g src="/demos/mj/cc_community_puzzle_gameplay.png" alt="Gameplay" class="mb-5">
                           <p class="text-muted mb-0 feature-slider-text">
                              <strong class="font-secondary">Browse our library of free puzzles</strong> to solve, play, and share
                              puzzles created by our community.
                           </p>
                           <a
                              href="/crossword/create/browse"
                              target="_blank"
                              class="button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                           >
                              Play Now
                           </a>
                        </div>
                     </div>
                     <div class="swiper-slide swiper-slide-active" role="group" aria-label="4 / 6" style="width: 374.5px; margin-right: 40px;" data-swiper-slide-index="0">
                        <div class="d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg">
                           <h3 class="mb-3">
                              Mini Crossword Creator
                           </h3>
                           <img g src="/demos/mj/cc_crossword_creator_gameplay.png" alt="Gameplay" class="mb-5">
                           <p class="text-muted mb-0 feature-slider-text">
                              <strong class="font-secondary">Create and share you own puzzles</strong> directly in the browser using our free 
                              Crossword Creator tool.
                           </p>
                           <a
                              href="/crossword/create"
                              target="_blank"
                              class="button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                           >
                              Create Puzzles
                           </a>
                        </div>
                     </div>
                     <div class="swiper-slide swiper-slide-active" role="group" aria-label="5 / 6" style="width: 374.5px; margin-right: 40px;" data-swiper-slide-index="0">
                        <div class="d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg">
                           <h3 class="mb-3">
                              Crossword Upload
                           </h3>
                           <img g src="/demos/mj/cc_upload_gameplay.png" alt="Gameplay" class="mb-5">
                           <p class="text-muted mb-0 feature-slider-text">
                              <strong class="font-secondary">Upload and play .ipuz files</strong> directly in your 
                              browser with our free Crossword Upload tool—no account required.
                           </p>
                           <a
                              href="/crossword/upload"
                              target="_blank"
                              class="button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                           >
                              Play Now
                           </a>
                        </div>
                     </div>
                     <div class="swiper-slide swiper-slide-active" role="group" aria-label="6 / 6" style="width: 374.5px; margin-right: 40px;" data-swiper-slide-index="0">
                        <div class="d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg">
                           <h3 class="mb-3">
                              Community Forum
                           </h3>
                           <img g src="/demos/mj/cc_community_forum_gameplay.png" alt="Gameplay" class="mb-5">
                           <p class="text-muted mb-0 feature-slider-text">
                              <strong class="font-secondary">Engage with other players</strong> in the community forum.
                           </p>
                           <a
                              href="/community/posts"
                              target="_blank"
                              class="button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                           >
                              Play Now
                           </a>
                        </div>
                     </div>
                  </div>
                  <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
               </div>
               <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                  <span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" aria-current="true">
                  </span>
                  <span class="swiper-pagination-bullet" tabindex="0"></span>
                  <span class="swiper-pagination-bullet" tabindex="0"></span>
                  <span class="swiper-pagination-bullet" tabindex="0"></span>
                  <span class="swiper-pagination-bullet" tabindex="0"></span>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div class="section bg-color bg-opacity-10 my-0">
      <div class="container py-5">
         <div class="row justify-content-center mb-4">
            <div class="col-md-6 text-center">
               <p class="color text-uppercase ls-3 small mb-3">Blog</p>
               <h3 class="display-5 mb-5">Our Latest Posts</h3>
            </div>
         </div>
         <div class="row col-mb-50 posts-md">
            <div class="col-lg-4 entry mb-0" v-for="post in posts.slice(0, 3)" :key=post.id>
               <ArticlePreview :post="post" />
            </div>
         </div>
      </div>
   </div>
   <div class="section bg-transparent my-0 py-0">
      <div class="container-fluid py-6">
         <div class="row justify-content-center mx-auto mw-md gx-5">
            <div class="col">
               <p class="h6 mb-0">
                  This site and its community are designed for entertainment and engagement. While we strive for 
                  accuracy in our puzzles and content, occasional errors may occur, and community contributions 
                  reflect individual opinions, not the views of the site.  If you have inquiries, wish to rectify misinformation, or 
                  seek clarification about our community, feel free to <a href="/about#contact">Contact Us</a>.
               </p>
            </div>
         </div>
      </div>
   </div>
</template>

 <script lang="ts">
 import { Vue, Options } from 'vue-class-component';
 import { Post } from '@/models/Cms';
 import { loadNewContent } from '@/utils/cms';
 import { convertTimeToDate } from '@/utils/time';
 import { APP_CONFIGS } from '@/main';
 import { FrameControl } from '@/models/FrameControl';
 import ArticlePreview from "@/components/post/ArticlePreview.vue";
 
 
 @Options({
     components: {
         ArticlePreview,
     }
 })
 export default class CCHome extends Vue {
 
     posts: Post[] = [];
 
     public async mounted(): Promise<void> {
         this.posts = await loadNewContent();
     }
 
     public convertTimeToDate(dateString: string): string {
         return convertTimeToDate(dateString);
     }
 
     get appConfigs(): FrameControl {
         return APP_CONFIGS;
     }
 
 }
 </script>
 
<style scoped>
.block-ellipsis {
   display: -webkit-box;
   max-width: 100%;
   margin: 0 auto;
   -webkit-line-clamp: 3;
   -webkit-box-orient: vertical;
   overflow: hidden;
   text-overflow: ellipsis;
   min-height: 75px;
}
.hero-img {
	opacity: .3;
}
.middle-section {
    position: relative;
    width: 100%;
    background-color: var(--cnvs-section-bg);
}
.title-text {
   text-shadow: 0.1px 0.1px 0 black;
   -webkit-text-shadow: 0.1px 0.1px 0 black;
}
.feature-slider-bg {
   background-color: white;
}
.feature-slider-text {
   min-height: 5rem;
}
.swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
    bottom: var(--swiper-pagination-bottom, 8px);
    width: 100%;
    position: relative;
    top: 50px;
}
.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 100px var(--swiper-pagination-bullet-horizontal-gap, 4px);
}
</style>